import { action } from 'typesafe-actions';
import { DocActionTypes } from './types';
import { IFinanceDocuments } from '../../../types';

export const addRequiredDocument = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  newDocType: string,
  metadata?: any
) =>
  action(DocActionTypes.ADD_REQUIRED_DOCUMENT, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    newDocType,
    metadata
  });

export const addRequiredDocumentSuccess = (financeDocuments: IFinanceDocuments) =>
  action(DocActionTypes.ADD_REQUIRED_DOCUMENT_SUCCESS, financeDocuments);

export const addRequiredDocumentFailure = (error: string) =>
  action(DocActionTypes.ADD_REQUIRED_DOCUMENT_FAILURE, { error });

export const saveMetaDataForNoDoc = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  metadata?: any
) =>
  action(DocActionTypes.SAVE_METADATA_FOR_NO_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    metadata
  });

export const saveMetaDataForNoDocSuccess = (financeDocuments: IFinanceDocuments) =>
  action(DocActionTypes.SAVE_METADATA_FOR_NO_DOC_SUCCESS, financeDocuments);

export const saveMetaDataForNoDocFailure = (error: string) =>
  action(DocActionTypes.SAVE_METADATA_FOR_NO_DOC_FAILURE, { error });

export const toggleAcknowledge = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  status: string,
  infoOnlyRequirementsOption = '',
  metadata: any
) =>
  action(DocActionTypes.TOGGLE_ACKNOWLEDGE_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    status,
    infoOnlyRequirementsOption,
    metadata
  });

export const toggleAcknowledgeSuccess = (financeDocuments: IFinanceDocuments) =>
  action(DocActionTypes.TOGGLE_ACKNOWLEDGE_DOC_SUCCESS, financeDocuments);

export const toggleAcknowledgeFailure = (error: string) =>
  action(DocActionTypes.TOGGLE_ACKNOWLEDGE_DOC_FAILURE, { error });
